// extracted by mini-css-extract-plugin
export var fadeIn = "_95-0";
export var panelInner = "_95-2";
export var panelOuter = "_95-1";